module.exports = __webpack_public_path__ + "img/okback1.fa4c23d7.png";